import { Router } from 'vue-router';
import { userAccountRoutes } from './userAccountRoutes';
import { userHomeRoutes } from './userHomeRoutes';
import { userOrderRoutes } from './userOrderRoutes';

export async function addUserRoutes(router: Router) {
  await userOrderRoutes.forEach((route) => router.addRoute(route));
  await userAccountRoutes.forEach((route) => router.addRoute(route));
  await userHomeRoutes.forEach((route) => router.addRoute(route));
}
